<template>
	<div class="container-fluid bg-default-color">
		<service-toolbar :show-title-widget="true" active-tab="dashboard"></service-toolbar>

		<div class="alert alert-warning" v-if="showLocationError">
			<i class="fa fa-exclamation-triangle"></i>
			We couldn'get get your location. Please enable location services for the app and your phone, and try again. <a href="/punch-clock">Clock In Form</a>
		</div>

		<div class="row">
			<div class="col-md-6">
				<widget title="Service Details" icon="fa-wrench" :header-button="userIsAdminOrHasServiceModuleWrite ? 'fa-pencil-alt' : false" v-on:headerButtonClick="editServiceDetails" :no-padding="true">

					<table class="table table-striped table-sm mb-0">
						<thead></thead>
						<tbody>
							<tr>
								<th>Service <template v-if="$store.service.status == 'Quote'">Quote</template> #</th>
								<td>{{$store.service.job_num}}</td>
							</tr>
							<tr v-if="$store.service.job_name">
								<th>Service Name</th>
								<td>{{$store.service.job_name}}</td>
							</tr>
							<tr v-if="'Job' in $store.service && $store.service.Job">
								<th>Attached to Project</th>
								<td><router-link :to="'/project/'+$store.service.Job.slug+'/dashboard'">#{{$store.service.Job.job_num}} {{$store.service.Job.job_name}}</router-link></td>
							</tr>
							<tr>
								<th>Customer PO</th>
								<td>{{$store.service.customer_po}}</td>
							</tr>
							<tr v-if="$store.service.Category">
								<th>Category</th>
								<td>{{$store.service.Category ? $store.service.Category.name : ""}}</td>
							</tr>
							<tr v-if="$store.service.Customer">
								<th>Customer</th>
								<td>{{$store.service.Customer.name}}</td>
							</tr>
							<tr v-if="$store.service.Customer">
								<th>Customer Phone</th>
								<td>{{$store.service.Customer.phone}}</td>
							</tr>
							<tr>
								<th>PO Date</th>
								<td>{{$store.service.date_landed}}</td>
							</tr>
							<tr>
								<th>Date Scheduled</th>
								<td>{{$store.service.due_date}}</td>
							</tr>
							<tr>
								<th>Work to Do</th>
								<td v-html="stripInlineEventHandlers($store.service.description)"></td>
							</tr>
							<tr>
								<th>Crew Members</th>
								<td>{{serviceCrewMembers}}</td>
							</tr>
							<tr>
								<th>Time Estimate</th>
								<td>{{$store.service.estimated_time}}</td>
							</tr>
							<tr>
								<th>Status</th>
								<td>{{ $store.service.status ? $store.service.status : 'Active' }}</td>
							</tr>
							<tr v-if="$store.service.status =='Canceled'">
								<th>Cancelation Reason</th>
								<td>{{ $store.service.canceled_reason }}</td>
							</tr>
							<tr>
								<th>Last Signed by Customer</th>
								<td v-if="$store.service.last_signed">{{ formatDateTimeToLocal($store.service.last_signed) }}</td>
								<td v-else>[Never]</td>
							</tr>
							<tr v-if="$store.service.address != ''">
								<th>Address</th>
								<td>
									<template v-if="customerLocationDisplay">{{ customerLocationDisplay }}<br></template>
									<template v-if="$store.service.suite">{{$store.service.suite}}-</template>{{$store.service.address}}<br>
									{{$store.service.city}}, 
									{{$store.service.province}}<br>
									{{$store.service.country}}<br>
									{{$store.service.postal_code}}<br>
								</td>
							</tr>
							<tr v-else>
								<th>Location</th>
								<td>
									<!--<a href="#" v-on:click.prevent="showMap">-->
									{{$store.service.lat}} {{$store.service.long}}
									<!--</a>-->
								</td>
							</tr>
							<tr>
							<th>Permit Required</th>
								<td v-html="stripInlineEventHandlers($store.service.permit_needed == 1 ? '<i class=\'fa fa-check\'></i>' : '<i class=\'fa fa-times\'></i>')"></td>
							</tr>
							<tr v-if="$store.service.permit_needed == 1">
								<th>Permit Notification #</th>
								<td>{{ $store.service.permit_notification_number }}</td>
							</tr>
							<tr>
								<th>Locates</th>
								<td v-if="'LocateTicket' in $store.service && $store.service.LocateTicket.filter(ticket => ticket.archived != 1).length > 0">
									<i class='fa fa-check'></i> (<router-link to="locates">{{ $store.service.LocateTicket.filter(ticket => ticket.archived != 1).length }} on file</router-link>)
								</td>
								<td v-else>None. <router-link to="locates">Add a locate...</router-link></td>
							</tr>
						</tbody>
					</table>

					<job-map v-if="showDashboardMap"
						:job-location="{
							lat: +$store.service.lat,
							lng: +$store.service.long
						}"
						:map-zoom="10"
						:check-in-tolerance="+$store.service.check_in_tolerance">
					</job-map>
					<button v-else class="btn btn-light" v-on:click="showDashboardMap = true">
						<i class="fa fa-map"></i>
						Show Map
					</button>

				</widget>

				<widget v-if="$store.service.internal_notes" title="Internal Service Notes">
					<pre v-html="stripInlineEventHandlers($store.service.internal_notes)"></pre>
				</widget>

				<widget v-if="'Customer' in $store.service && $store.service.Customer && $store.service.Customer.notes" :title="'Notes about ' + $store.service.Customer.name">
					<pre v-html="stripInlineEventHandlers($store.service.Customer.notes)"></pre>
				</widget>

				<widget v-if="'ContactLocation' in $store.service && $store.service.ContactLocation && $store.service.ContactLocation.notes" title="Customer Location Notes">
					<pre v-html="stripInlineEventHandlers($store.service.ContactLocation.notes)"></pre>
				</widget>

				<widget v-if="mutatedServiceContacts.length > 0" title="Service Contacts" icon="fa-users">
					<table-list
						:records="mutatedServiceContacts"
						:fields="$store.contactFields"
						record-name="Contact"
						:hide-record-count="true">
					</table-list>
				</widget>

				<widget title="Images & Files" icon="fa-image">

					<div 
						v-for="img in images"
						:style="{backgroundImage:'url('+img.src+')'}"
						class="image-tile"
						v-on:click="showImage(img)">
					</div>

					<image-viewer v-if="showImageViewer" :url="imageViewerUrl" v-on:close="showImageViewer = false"></image-viewer>

					<h4>Files</h4>
					<file-list-item 
						v-for="(file,index) in files"
						:key="file.src"
						:id="file.fileId"
						:src="file.src"
						:filename="file.filename"
						:size-kb="file.sizeKb"
						:non-editable='true'>	
					</file-list-item>
				</widget>
			</div>
			<div class="col-md-6">

				<div v-if="userHasReviewTimeLogsPerm && !allTimeLogsReviewed" class="mb-2">

					<div>
						<button :disabled="!noOpenLogs && $store.service.status == 'Completed'" class="btn btn-light" v-on:click="reviewConfirmModal.visible = true">
							<i class="fa fa-check"></i>
							Mark as "Reviewed"
						</button>

						<modal-dialog
							title="Mark as Reviewed?"
							confirm-button-text="Reviewed"
							button-class="btn-success"
							:modal-visible="reviewConfirmModal.visible"
							modal-size="modal-lg"
							v-on:confirm="reviewService"
							v-on:closeModal="reviewConfirmModal.visible = false">

							Please check the following time logs for accuracy, then click the "Reviewed" button below to mark them as reviewed.

							<table-list
								:fields="reviewConfirmModalFields"
								:records="mutatedTimeLogs"
								:hide-record-count="true"
								record-name="Time Log"
								id-field="slug">
							</table-list>
						</modal-dialog>
					</div>

					<div v-if="!noOpenLogs && userHasReviewTimeLogsPerm" class="text-muted">
						There are open time logs, so this service is not reviewable yet
					</div>
				</div>

				<widget title="Personnel">
					<!--<h4 class="mb-0">Roles</h4>-->
					<table-list	:fields="[
							{label: 'Role',key:'roleName'},
							{label: 'Name', key:'userName'},
							{label: 'Phone', key: 'userPhone'}
						]"
						:records="jobPersonnelList"
						:hide-record-count="true">
					</table-list>
				</widget>

				<group-clock-modal v-if="'id' in $store.service"
					:visible="groupClockModalVisible"
					:service-id="$store.service.id"
					v-on:closeModal="groupClockModalVisible = false"
					v-on:usersClockedIn="fetchTimeLogs"
					v-on:usersClockedOut="fetchTimeLogs">
				</group-clock-modal>

				<job-schedule-timeline-widget v-if="!isFreemiumUser"
					:service-id="$store.service.id">
				</job-schedule-timeline-widget>

				<!--
				<messages-widget v-if="'id' in $store.service" :service-id="$store.service.id"></messages-widget>
				-->

				<widget v-if="$store.service.status != 'Quote'" title="Clock in History" icon="fa-clock" max-height="400px">
					<button
						v-if="userHasReviewTimeLogsPerm || userIsAdminOrHasServiceModuleWrite"
						class="btn btn-success mr-1" v-on:click="newTimeLogRecord">
						<i class="fa fa-plus"></i>
						Time Log Record
					</button>

					<button v-if="hasTimeLogWritePermsOnService" 
						class="btn btn-success" 
						v-on:click="openGroupClockModal">
						<i class="fa fa-users"></i>
						<i class="fa fa-clock"></i>
						Group Clock In/Out
					</button>

					<time-log-manual-entry-modal 
						title="Create a Time Log" 
						:visible="timeLogModalVisible"
						record-type="retro"
						project-or-service="service"
						:job-id="$store.service.id"
						v-on:closeModal="timeLogModalVisible = false"
						v-on:modelChange="fetchTimeLogs">
					</time-log-manual-entry-modal>

					<table-list
						:records="mutatedTimeLogs"
						:fields="timeLogWidgetFields"
						:hide-record-count="true"
						record-name="Time Log">
					</table-list>
				</widget>

				<!--
				<widget v-if="$store.service.status != 'Quote'" title="Work Completed" icon="fa-wrench" header-button="fa-pencil-alt" v-on:headerButtonClick="editWorksheet">

					<table class="table table-sm" v-if="$store.service.WorkCompletedBy" >
						<tr>
							<th>Done By</th>
							<td>{{ $store.service.WorkCompletedBy.first_name }} {{ $store.service.WorkCompletedBy.last_name }}</td>
						</tr>
						<tr>
							<th>Done At</th>
							<td>{{ formatDateTimeToLocal($store.service.work_completed_at) }}</td>
						</tr>
						<tr>
							<th>Total Time Spent</th>
							<td>{{ totalTimeSpent.toFixed(2) }}</td>
						</tr>
						<tr>
							<th colspan="2">Work Completed:</th>
						</tr>
						<tr>
							<td colspan="2" v-html="stripInlineEventHandlers($store.service.work_completed_description)"></td>
						</tr>
					</table>
					<p v-else class="text-muted mb-0">
						Work has not commenced yet
					</p>

				</widget>
			-->

				<widget v-if="$store.service.status != 'Quote'" title="Materials Used" icon="fa-barcode">

					<table-list
						record-name="Material"
						:records="materialsUsed"
						:fields="materialsUsedFields">
					</table-list>

				</widget>

				<widget v-if="$store.service.status != 'Quote'" title="Service QR Code">
					<div class="d-flex justify-content-between mt-4">
						<vue-qr-code
							:params="{
								text: buildRedirectLink('service', $store.service.slug),
								width: 250,
								height: 250
							}"
							logo-url="/resources/icons/logo_dark_icon_192.png"
							logo-classes="p-1 rounded"
							:title="'Service - #'+$store.service.job_num"
							:show-copy-button="true">
						</vue-qr-code>
					</div>
				</widget>
			</div>
		</div>

		
	</div>
</template>
<script type="text/javascript">
import ServiceToolbar from "./ServiceToolbar"
import ArchivedAlert from './ArchivedAlert'
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import FileListItem from "@/components/FileListItem"
import ImageViewer from "@/components/ImageViewer"
import MessagesWidget from "@/components/widgets/MessagesWidget"
import JobMap from "@/components/JobMap"
import VueQrCode from "@/components/VueQrCode.vue"

import JobScheduleTimelineWidget from "@/components/widgets/JobScheduleTimelineWidget"

import GroupClockModal from "@/components/super_components/GroupClockModal"

import TimeLogManualEntryModal from "@/components/super_components/TimeLogManualEntryModal"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServiceDashboard",
	components: {
		ServiceToolbar,
		ArchivedAlert,
		Widget,
		TableList,
		Field,
		TimeLogManualEntryModal,
		ModalDialog,
		FileListItem,
		ImageViewer,
		MessagesWidget,
		GroupClockModal,
		JobMap,
		JobScheduleTimelineWidget,
		VueQrCode
	},
	mixins: [ServiceMixins],
	data() {
		return {
			threads: [],
			serviceTimeLogs: [],
			timeLogWidgetFields: [
				{label: "Employee",key:"fullName"},
				{label: "Date",key:"formattedTimeIn"},
				{label: "Time Spent",key:"timeSpent",align:"right"},
				{label: "Reviewed",key:"reviewedStatus",type:"boolean",align:"center"},
			],
			materialsUsedFields: [
				{label: "Description",key:"description"},
				{label: "Part Number", key: "part_number"},
				{label: "QTY", key: "qty"}
			],
			timeLogModalVisible: false,
			showLocationError: false,
			apiRoot: window.apiRoot,
			apiBase: window.apiBase,
			reviewConfirmModal: {
				visible: false
			},
			showImageViewer: false,
			imageViewerUrl: "",
			showDashboardMap: false,
			groupClockModalVisible: false,
			helperTechs: []
		}
	},
	watch: {
		'$store.service'() {
			if (this.serviceTimeLogs.length == 0)
				this.fetchTimeLogs()
		}
	},
	computed: {
		customerLocationDisplay() {
			const loc = this.$store.service && this.$store.service.ContactLocation
			if (!loc || !loc.location_name) return ''
			if (String(loc.location_name).trim().toLowerCase() === 'main') return ''
			return loc.location_name
		},
		serviceCrewMembers() {
			let members = ""

			// Set Lead
			if ('AssignedTo' in this.$store.service && this.$store.service.AssignedTo) {
				members += this.$store.service.AssignedTo.first_name + " " + this.$store.service.AssignedTo.last_name +
					" (lead)"
			}

			if ('HelperTechs' in this.$store.service && this.$store.service.HelperTechs) {
				this.$store.service.HelperTechs.forEach(helperTech => {
					members += ", " + helperTech.first_name + " " + helperTech.last_name + " (helper)"
				})
			}

			return members
		},
		jobPersonnelList() {
			let vm = this

			let list = []
			if ("User" in this.$store.service) {
				list = this.$store.service.User.map(user => {
					user.userName = user.first_name+" "+user.last_name
					user.userPhone = user.phone_mobile
					
					user.roleName = ""

					if (user.personnel_role_id > 0) {
						let role = vm.$store.jobPersonnelRoles.find(role => role.id == user.personnel_role_id)

						user.roleName = ""
						if (role)
							user.roleName = role.title
					}

					return user
				})

				//list lead
				if ("AssignedTo" in this.$store.service && this.$store.service.AssignedTo) {
					let assignedTo = this.$store.service.AssignedTo

					list.push({
						userName: assignedTo.first_name+ " "+assignedTo.last_name,
						userPhone: assignedTo.phone_mobile,
						roleName: "Lead Crew Member"
					})
				}

				list = [
					...list,
					...vm.helperTechs.map(user => {
						user.userName = user.first_name+" "+user.last_name
						user.userPhone = user.phone_mobile
						
						user.roleName = "Helper"

						return user
					})
				]
			}

			return list
		},
		scheduledList() {
			let list = []

			return list
		},
		noOpenLogs() {
			let vm = this

			let openLogs = this.serviceTimeLogs.filter(log => {
				if (log.time_out == "0000-00-00 00:00:00")
					return true
			})

			if (openLogs.length > 0)
				return false
			else
				return true
		},
		hasTimeLogWritePermsOnService() {
			let vm = this

			if (this.hasModulePermWrite("TimeLogs"))
				return true;
			else 
				return this.hasRoleBasedPermission("service",this.$store.service.id,"write_timelogs")
		},
		reviewConfirmModalFields() {
			let vm = this

			let hasReg = false
			let hasOT15 = false
			let hasOT2 = false
			let hasOT25 = false

			this.serviceTimeLogs.forEach(log => {
				if (log.regular_hours > 0)
					hasReg = true

				if (log.overtime_hours_15x > 0)
					hasOT15 = true

				if (log.overtime_hours_2x > 0)
					hasOT2 = true

				if (log.overtime_hours_25x > 0)
					hasOT25 = true
			})

			let fields = [
				{label: "Employee",key:"fullName"},
				{label: "Date",key:"formattedTimeIn"},
				{label: "Elapsed Time",key:"elapsedTime",align:"right"},
			]

			if (hasReg)
				fields.push({label: "Reg Hrs",key:"regular_hours",align:"right"})

			if (hasOT15)
				fields.push({label: "OT 1.5x Hrs",key:"overtime_hours_15x",align:"right"})

			if (hasOT2)
				fields.push({label: "OT 2x Hrs",key:"overtime_hours_2x",align:"right"})

			if (hasOT25)
				fields.push({label: "OT 2.5x Hrs",key:"overtime_hours_25x",align:"right"})

			fields.push({label: "Onsite",key:"onSite",type:"boolean"})

			return fields

		},
		userIsAdminOrHasServiceModuleWrite() {

			let modulePerms = this.getUserModulePerms()
			if (!("Services" in modulePerms)) {
				modulePerms.Services = {
					write: false
				}
			}

			if (this.getUserRoleType() == "Admin" || modulePerms.Services.write)
				return true
			else
				return false
		},
		userHasReviewTimeLogsPerm() {
			let vm = this

			let hasReviewPerms = false
			if ("JobPersonnelRole" in this.$store.service) {
				this.$store.service.JobPersonnelRole.forEach(role => {
					if (role.user_id == vm.$store.userDetails.id && role.review_timelogs == 1)
						hasReviewPerms = true
				})
			}

			return hasReviewPerms
		},
		allTimeLogsReviewed() {
			let vm = this

			let allLogsReviewed = true
			this.serviceTimeLogs.forEach(log => {
				if (log.reviewed_by == 0)
					allLogsReviewed = false
			})

			return allLogsReviewed
		},
		materialsUsed() {
			let materials = []

			if ("ServiceWorksheet" in this.$store.service && this.$store.service.ServiceWorksheet) {
				this.$store.service.ServiceWorksheet.forEach(ws => {
					try {
						let wsMaterials = JSON.parse(ws.parts_used_json)
						materials = materials.concat(wsMaterials)
					}
					catch (e) {}
				})
			}

			return materials
		},
		mapSrc() {
			let destination_query

			if (this.$store.service.location_type == "address") 
				destination_query = this.$store.service.address+"+"+this.$store.service.city+"+"+this.$store.service.province+"+"+this.$store.service.country+"+"+this.$store.service.postal_code
			else 
				destination_query = this.$store.service.lat+","+this.$store.service.long

			return 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+destination_query
		},
		totalTimeSpent() {
			let totalTimeSpent = 0

			if (this.serviceTimeLogs.length == 0)
				return 0

			return this.serviceTimeLogs.reduce((sum, log) => {
				return sum + parseFloat(log.regular_hours) + 
							parseFloat(log.overtime_hours_15x) + 
							parseFloat(log.overtime_hours_2x) + 
							parseFloat(log.overtime_hours_25x)
			},0)
		},
		mutatedServiceContacts() {
			let vm = this

			if ("ServiceContact" in this.$store.service) {
				return this.$store.service.ServiceContact.filter(contact => "Contact" in contact && contact.Contact).map(contact => {

					if (contact.Contact && contact.Contact) {
						contact.name = contact.Contact.name
						
						contact.phone = {
							text: contact.Contact.phone,
							link: "tel:"+contact.Contact.phone
						}

						contact.email = {
							text: contact.Contact.email,
							link: "mailto:"+contact.Contact.email
						}

						if ("Company" in contact.Contact && contact.Contact.Company)
							contact.company = contact.Contact.Company.name
						else
							contact.company = ""
					}

					contact.role = contact.role

					return contact
				})
			}
			else
				return []
		},
		mutatedTimeLogs() {
			let vm = this

			return vm.serviceTimeLogs.map(log => {
				log.fullName = log.User.first_name+ " " + log.User.last_name
				log.formattedTimeIn = vm.formatDateTimeToLocal(log.time_in)

				log.elapsedTime = vm.dateDiff(log.time_in,log.time_out,"hrs")

				if (log.time_out == "0000-00-00 00:00:00") {
					log.timeSpent = "TBD"
					log.elapsedTime = "TBD"
				}
				else
					log.timeSpent = (parseFloat(log.regular_hours) + 
								parseFloat(log.overtime_hours_15x) + 
								parseFloat(log.overtime_hours_2x) + 
								parseFloat(log.overtime_hours_25x)).toFixed(2)

				log.onSite = log.clocked_in_offsite == 1 ? false : true

				log.reviewedStatus = false
				if (log.reviewed_by > 0)
					log.reviewedStatus = true

				return log
			})
		},
		files() {
			let vm = this

			if (this.$store.service.ServiceFile) {
				return this.$store.service.ServiceFile.filter(file => {
					if ("UploadFile" in file && file.UploadFile && file.UploadFile.type == 'File')
						return true
					else return false
				}).map(file => {

					file.fileId = file.UploadFile.id
					file.filename = file.UploadFile.original_filename
					file.label = file.UploadFile.original_filename
					file.src = window.apiRoot+"resources/files/"+vm.$store.sessionToken+"/"+file.UploadFile.filename
					file.sizeKb = file.UploadFile.file_size_kb

					return file
				})
			}
			else
				return []
		},
		images() {
			let vm = this

			if (this.$store.service.ServiceFile) {
				return this.$store.service.ServiceFile.filter(file => {
					if ("UploadFile" in file && file.UploadFile && file.UploadFile.type != 'File')
						return true
				}).map(image => {
					image.thumb_filename = image.UploadFile.filename
					image.filename = image.UploadFile.filename

					if (image.UploadFile.thumb_filename)
						image.thumb_filename = image.UploadFile.thumb_filename

					image.src = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.filename

					return image
				})
			}
			else
				return []
		}
	},
	methods: {
		showMap() {

		},
		showWOSummary() {

		},
		showImage(img) {
			this.showImageViewer = true
			this.imageViewerUrl = this.apiRoot+'resources/images/'+this.$store.sessionToken+'/'+img.filename
		},
		reviewService() {
			let timeLogRecords = []

			let vm = this

			this.serviceTimeLogs.forEach(log => {
				timeLogRecords.push({
					id: log.id,
					reviewed_by: vm.$store.userDetails.id
				})
			})

			let payload = {
				records: timeLogRecords
			}

			this.postData("TimeLog/save-batch",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Service time logs marked as reviewed")
					vm.reviewConfirmModal.visible = false
				}
			})
		},
		selectThread(thread) {
			this.$store.serviceActiveThread = thread
		},
		newTimeLogRecord() {
			this.timeLogModalVisible = true
		},
		openGroupClockModal() {
			this.groupClockModalVisible = true
		},
		editServiceDetails() {
			this.$router.push("/service/"+this.$route.params.id+"/details")
		},
		editWorksheet() {
			this.$router.push("/service/"+this.$route.params.id+"/worksheet")
		},
		fetchTimeLogs() {
			let vm = this

			if ("id" in this.$store.service) {
				let filters = [
					["service_id",this.$store.service.id]
				]

				this.getJSON("TimeLog/get",{filters:filters,include:["User"]},true).then(response => {
					vm.serviceTimeLogs = response.data
				})
			}
		}
	},
	created() {
		let vm = this

		if (!("id" in this.$store.service) || this.$store.service.slug != this.$route.params.id || !("LocateTicket" in this.$store.service)) {
			this.fetchService().then(response => {
				if (vm.$store.service.helper_techs_json.length > 2) {

					let helperIds = JSON.parse(vm.$store.service.helper_techs_json)

					try {

						vm.getJSON("User/get",{
							filters: [
								["id", helperIds]
							],
							fields: ["id","slug","first_name","last_name","phone_mobile"]
						}).then(response => {
							vm.helperTechs = response.data
						})
					}
					catch (e) {}
				}
			})
		}
		else 
			this.fetchTimeLogs()
		

		this.fetchJobPersonnelRoles()
	}
}
</script>

<style type="text/css" scoped>
	pre {
		word-wrap: break-word;
		white-space: pre-wrap;
		font-family: inherit;
		font-size: 100%;
	}

	.image-tile {
		width: 60px;
		height: 60px;
	}

</style>